import { useSignals } from '@preact/signals-react/runtime';
import { WixContext } from '@wix/sdk-react-context';
import React, { useContext } from 'react';
export function ServicesManagerProvider({ servicesManager, children, }) {
    return (React.createElement(WixContext.Provider, { value: servicesManager }, children));
}
export function useService(service) {
    useSignals();
    const servicesManager = useContext(WixContext);
    if (!servicesManager) {
        throw new Error('No ServiceManagerProvider found in the component tree, make sure to wrap your app with ServicesManagerProvider');
    }
    return servicesManager.getService(service);
}
export function useServices(services) {
    const servicesManager = useContext(WixContext);
    if (!servicesManager) {
        throw new Error('No ServiceManagerProvider found in the component tree, make sure to wrap your app with ServicesManagerProvider');
    }
    return services.map((service) => servicesManager.getService(service));
}
